const Data = [
    {
        id: 1,
        text: "Optimize Linkedin Account",
        day: "Oct 10th at 2:30pm",
        reminder: true
      },
      {
        id: 2,
        text: "Read 48 Laws of Power",
        day: "Oct 11th at 2:00pm",
        reminder: true
      },
      {
        id: 3,
        text: "Play Chess With Her",
        day: "Oct 12th at 3:30pm",
        reminder: true
      }
]
export default Data